import DashboardIcon from "@mui/icons-material/Dashboard";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
import LocalPostOfficeIcon from "@mui/icons-material/LocalPostOffice";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import HomeRepairServiceIcon from "@mui/icons-material/HomeRepairService";
import NoCrashIcon from "@mui/icons-material/NoCrash";
import HailIcon from "@mui/icons-material/Hail";
import AddBoxIcon from "@mui/icons-material/AddBox";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import DescriptionIcon from "@mui/icons-material/Description";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ReceiptIcon from "@mui/icons-material/Receipt";
import PaymentsIcon from "@mui/icons-material/Payments";
import FlightIcon from '@mui/icons-material/Flight';


export const supermenu = [
  {
    icon: <DashboardIcon />,
    title: "Dashboard",
    to: "/super/dashboard",
  },
  {
    icon: <GroupAddIcon />,
    title: "Users",
    to: "/super/admin",
    items: [
      {
        icon: <SupervisorAccountIcon />,
        title: "Admins",
        to: "/super/admin",
      },
      {
        icon: <AccountBoxIcon />,
        title: "Customer",
        to: "/super/customer",
      },
      {
        icon: <LocalPostOfficeIcon />,
        title: "Office Notices",
        to: "/super/office-notices",
      },
      {
        icon: <ContactMailIcon />,
        title: "Customer Notices",
        to: "/super/customer-notices",
      },
      {
        icon: <HailIcon />,
        title: "Pick Up",
        to: "/super/pickup",
      },
    ],
  },
  {
    icon: <MiscellaneousServicesIcon />,
    title: "Service Providers",
    to: "/super/service-provider",
  },
  {
    icon: <HomeRepairServiceIcon />,
    title: "Shipments",
    items: [
      {
        icon: <AddBoxIcon sx={{ ml: "-8px" }} />,
        title: "Add Shipment",
        to: "/super/add-shipment-lite",
      },
      {
        icon: <FlightIcon sx={{ ml: "-8px" }} />,
        title: "Master AWB",
        to: "/super/master-awb",
      },
      {
        icon: <LocalShippingIcon sx={{ ml: "-8px" }} />,
        title: "Requests",
        to: "/super/shipment-lite",
      },
      {
        icon: <NoCrashIcon sx={{ ml: "-8px" }} />,
        title: "Confirmed",
        to: "/super/final-shipments",
      },
      {
        icon: <ReceiptIcon sx={{ ml: "-8px" }} />,
        title: "Billed",
        to: "/super/billed-shipments",
      },
    ],
  },
  {
    icon: <PaymentsIcon />,
    title: "Payment",
    to: "/super/payments",
  },
  {
    icon: <AssessmentIcon />,
    title: "Reports",
    items: [
      {
        icon: <DescriptionIcon sx={{ ml: "-8px" }} />,
        title: "Bills",
        to: "/super/bill",
      },
      {
        icon: <NoteAddIcon sx={{ ml: "-8px" }} />,
        title: "Generate",
        to: "/super/reports",
      },
    ],
  },
];
